<template>
    <transition name="fade">
        <div class="submit-result">
            <div class="container">
                <div class="container-box">
                    <img src="@/assets/images/icon-match-upload-result.png" alt="" class="icon-result" />
                    <div class="submit-title">作品提交成功</div>
                    <div class="submit-desc">定制样衣,完美落地你的设计创意,</div>
                    <div class="submit-slogan">创意变现,触手可及!</div>
                    <div class="submit-design" @click="$emit('confirm')">立即定制样衣</div>
                    <div class="submit-apply" @click="$emit('apply')">已有样衣，申请开店上架</div>

                    <div class="submit-later" @click="$emit('close')">稍候再说</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    name:"SubmitResult",
    data(){
        return{}
    },
    mounted(){},
    methods:{}
}
</script>
<style lang="scss" scoped>
.submit-result{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 119;
    display:flex;
    align-items:center;
    justify-content:center;
    user-select:none;
    overflow:hidden;
    .container{
        width:480px;
        height:460px;
        background:#fff;
        border-radius:32px;
        .container-box{
            width:100%;
            height:100%;
            border-radius:32px;
            background:linear-gradient(to bottom,#ff59674D,#ffffff);
            display:flex;
            flex-direction:column;
            align-items:center;
            position: relative;
            .icon-result{
                width:192px;
                height:134px;
                position:absolute;
                top:-43px;
                left:50%;
                transform:translateX(-50%);
            }
            .submit-title{
                color:#000;
                font-size:24px;
                font-weight:bold;
                margin-top:120px;
            }
            .submit-desc{
                margin-top:15px;
                color:#333;
                font-size:20px;
            }
            .submit-slogan{
                margin-top:9px;
                color:#ff5967;
                font-size:22px;
            }
            .submit-design{
                width:325px;
                height:48px;
                background:#ff5967;
                color:#fff;
                display:flex;
                align-items:center;
                justify-content:center;
                cursor:pointer;
                border-radius:30px;
                margin-top:38px;
                box-shadow:0 6px 10px 0 rgba(240,79,92,0.5);
            }
            .submit-apply{
                width:325px;
                height:48px;
                background:#ffffff;
                color:#FF5967;
                display:flex;
                align-items:center;
                justify-content:center;
                cursor:pointer;
                border-radius:30px;
                margin-top:22px;
                border:1px solid #FF5967;
            }
            .submit-later{
                margin-top:26px;
                color:#666;
                font-size:14px;
                cursor:pointer;
            }
        }
    }
}
</style>